<div class="carousel-container">
  <div class="arrow-bg left" [class.show-arrow]="canPrev" (click)="prev()">
    <img alt="Left Arrow" src="./assets/images/white_left_arrow.png">
  </div>
  <div class="slides-wrapper">
    <div class="slides" [style.transform]="'translateX(-' + (currentIndex * 100) + '%)'">
      <div class="slide" *ngFor="let bundle of bundles; let i = index">
        <app-also-included [bundle]="bundle" [country]="country" [useIvan]="useIvan" [storeIsItunes]="storeIsItunes" (onClick)="handleClick($event, bundle)"></app-also-included>
      </div>
    </div>
  </div>
  <div class="arrow-bg right" [class.show-arrow]="canNext" (click)="next()">
    <img alt="Right Arrow" src="./assets/images/white_right_arrow.png">
  </div>
  <div class="dots" *ngIf="bundles.length > 1">
    <span *ngFor="let bundle of bundles; let i = index" [class.active]="i === currentIndex" (click)="goTo(i)"></span>
  </div>
</div>
